import { Box, Skeleton, Typography } from '@mui/material';
import {
  AccountType,
  Contact,
  ContactExtended,
} from '../../../../../../types/api';
import { INSTALLER_TYPES_LABELS } from '../../../constants';
import { useAuth } from '../../../hooks';
import { formatDate } from '../../../utils/formatters';
import { formatPhoneNumber } from '../../loan_application/utils/helpers';
import ContactRowActionMenu from './ContactRowActionMenu';
import ContactStatusChip from './ContactStatusChip';

type Props = {
  data: ContactExtended[];
  isLoading: boolean;
  setModalState: (state: { open: boolean; contact?: Contact }) => void;
};

export default function AccountContactsMobileList({
  data,
  isLoading,
  setModalState,
}: Props) {
  const { user } = useAuth();

  return (
    <Box display="flex" flexDirection="column" gap={1} px={1.75} pb={1.75}>
      {data.map((contact) => (
        <Box
          key={contact.id}
          border="1px solid #BFC9D4"
          borderRadius={1}
          px={2.25}
          py={2.5}
          sx={{ overflowWrap: 'anywhere' }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={1}
          >
            <Typography variant="h5">{contact.name}</Typography>
            <ContactRowActionMenu
              contact={contact}
              setModalState={setModalState}
            />
          </Box>

          <Box display="flex" alignItems="center" gap={1} mb={2}>
            <ContactStatusChip status={contact.status} />
            {user?.account.type === AccountType.INSTALLER && (
              <Typography variant="body1">
                {contact.installer_role
                  ? INSTALLER_TYPES_LABELS[contact.installer_role]
                  : '-'}
              </Typography>
            )}
          </Box>

          <Box mb={1}>
            <Typography variant="body2" color="text.secondary">
              Position Title
            </Typography>
            <Typography variant="body1">
              {contact.position_title ?? '-'}
            </Typography>
          </Box>

          <Box mb={1}>
            <Typography variant="body2" color="text.secondary">
              Email
            </Typography>
            <Typography variant="body1">{contact.email}</Typography>
          </Box>

          <Box mb={1}>
            <Typography variant="body2" color="text.secondary">
              Phone Number
            </Typography>
            <Typography variant="body1">
              {formatPhoneNumber(contact.phone ?? contact.mobile_phone) ??
                contact.phone ??
                contact.mobile_phone ??
                '-'}
            </Typography>
          </Box>

          <Box mb={1}>
            <Typography variant="body2" color="text.secondary">
              Last Login
            </Typography>
            <Typography variant="body1">
              {contact.last_login ? formatDate(contact.last_login) : '-'}
            </Typography>
          </Box>

          <Box mb={1}>
            <Typography variant="body2" color="text.secondary">
              Added By
            </Typography>
            <Typography variant="body1">
              {contact.created_by_user_contact?.name ?? '-'}
            </Typography>
          </Box>
        </Box>
      ))}

      {isLoading &&
        new Array(3)
          .fill(null)
          .map((_, i) => (
            <Skeleton
              variant="rectangular"
              width="96%"
              height={270}
              sx={{ my: 1, borderRadius: '12px', mx: 'auto' }}
              key={i}
            />
          ))}
    </Box>
  );
}
